import { create } from "zustand";
import { persist } from "zustand/middleware";

export type Theme = "system" | "light" | "dark";

interface ThemeState {
	theme: Theme;
	setTheme: (t: Theme) => void;
}

export const useThemeStore = create<ThemeState>()(
	persist(
		(set) => ({
			theme: "system",
			setTheme: (theme) => set({ theme }),
		}),
		{ name: "omnios-theme" },
	),
);

function resolvedTheme(theme: Theme): "light" | "dark" {
	if (theme !== "system") return theme;
	return window.matchMedia("(prefers-color-scheme: dark)").matches
		? "dark"
		: "light";
}

function apply(theme: Theme) {
	const resolved = resolvedTheme(theme);
	document.documentElement.classList.toggle("dark", resolved === "dark");
}

let mediaQuery: MediaQueryList | null = null;

export function initTheme() {
	apply(useThemeStore.getState().theme);

	useThemeStore.subscribe((s) => apply(s.theme));

	mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
	const handler = () => {
		if (useThemeStore.getState().theme === "system") {
			apply("system");
		}
	};
	mediaQuery.addEventListener("change", handler);
}
